/**
 * GoldFire Network (https://goldfire.me)
 * Copyright (c) 2012 - 2020, GoldFire Studios, Inc.
 * http://goldfirestudios.com
 */

import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import Layout from '../components/routes/Layout.vue';
import Index from '../components/routes/Index.vue';
import Terms from '../components/routes/Terms.vue';
import Privacy from '../components/routes/Privacy.vue';
import Contact from '../components/routes/Contact.vue';
import Players from '../components/routes/Players.vue';
import Forums from '../components/routes/Forums.vue';
import ForumsCategory from '../components/routes/ForumsCategory.vue';
import ForumsThread from '../components/routes/ForumsThread.vue';
import Login from '../components/routes/Login.vue';
import Signup from '../components/routes/Signup.vue';
import SocialConnect from '../components/routes/SocialConnect.vue';
import SocialSignup from '../components/routes/SocialSignup.vue';
import GuestComplete from '../components/GuestComplete.vue';
import Profile from '../components/routes/Profile.vue';
import Reset from '../components/routes/Reset.vue';
import ResetConfirmation from '../components/routes/ResetConfirmation.vue';
import ResetFinish from '../components/routes/ResetFinish.vue';
import Verify from '../components/routes/Verify.vue';
import Game from '../components/routes/Game.vue';
import PaypalDone from '../components/routes/PaypalDone.vue';
import ViewNotifications from '../components/routes/ViewNotifications.vue';
import Unsubscribe from '../components/routes/Unsubscribe.vue';
import MultiFactorAuth from '../components/routes/MultiFactorAuth.vue';

// Register the router & meta plugins with Vue.
Vue.use(Router);
Vue.use(Meta, {keyName: 'meta'});

// Setup the main site routes (the toolbar doesn't use routes).
export function createRouter() {
  return new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }

      return {x: 0, y: 0};
    },
    routes: [
      {
        path: '/',
        component: Layout,
        children: [{path: '', component: Index}],
      },
      {
        path: '/terms',
        component: Layout,
        children: [{path: '', component: Terms}],
      },
      {
        path: '/privacy',
        component: Layout,
        children: [{path: '', component: Privacy}],
      },
      {
        path: '/contact',
        component: Layout,
        children: [{path: '', component: Contact}],
      },
      {
        path: '/directory/:page?',
        component: Layout,
        children: [{path: '', component: Players}],
      },
      {
        path: '/forums',
        component: Layout,
        children: [{path: '', component: Forums}],
      },
      {
        path: '/forums/:category/:page?',
        component: Layout,
        children: [{path: '', component: ForumsCategory}],
      },
      { // This supports the old URL format
        path: '/forums/thread/post/:id/:pid',
        component: Layout,
        children: [{path: '', component: ForumsThread}],
      },
      {
        path: '/forums/thread/:id/:title/:page?/:pid?',
        component: Layout,
        children: [{path: '', component: ForumsThread}],
      },
      {
        path: '/forums/thread/:id/:title/post/:pid',
        component: Layout,
        children: [{path: '', component: ForumsThread}],
      },
      {
        path: '/login',
        component: Login,
      },
      {
        path: '/auth/connect',
        component: SocialConnect,
      },
      {
        path: '/auth/signup',
        component: SocialSignup,
      },
      {
        path: '/auth/complete',
        component: GuestComplete,
      },
      {
        path: '/bye',
        component: Login,
      },
      {
        path: '/login/auth',
        component: MultiFactorAuth,
      },
      {
        path: '/signup',
        component: Login,
        meta: {signup: true},
      },
      {
        path: '/signup/2',
        component: Signup,
      },
      {
        path: '/login/reset',
        component: Reset,
      },
      {
        path: '/login/reset/2',
        component: ResetConfirmation,
      },
      {
        path: '/login/reset/3/:user/:key',
        component: ResetFinish,
      },
      {
        path: '/verify/:user/:key',
        component: Layout,
        children: [{path: '', component: Verify}],
      },
      {
        path: '/purchase/done',
        component: PaypalDone,
      },
      {
        path: '/view/notifications',
        component: ViewNotifications,
      },
      {
        path: '/email/unsubscribe/:sig/:email',
        component: Unsubscribe,
      },
      {
        path: '/u/:user',
        component: Layout,
        children: [{path: '', component: Profile}],
      },

      // Priority is by order, so the game route should
      // always be at the end of this list so that it is matched last.
      {
        path: '/:game',
        component: Game,
        meta: {game: true},
      },
    ],
  });
}
